import useInView from 'react-cool-inview';

const TIME_VISIBLE_IN_VIEWPORT = 1000;

export type ViewObserverProps =
  | Parameters<typeof useInView>[0]
  | undefined
  | null;

export default function useViewObserver(inViewConfig: ViewObserverProps = {}) {
  const element = useInView<HTMLElement | null>({
    threshold: 1,
    delay: TIME_VISIBLE_IN_VIEWPORT,
    ...inViewConfig,
  });

  return {
    ...element,
  };
}
